import { useSplitTreatments } from '@splitsoftware/splitio-react/'

const featureName = 'CE_PRICING_END_OF_TRIAL'
export const usePricingEndOfTrial = () => {
  const {
    treatments: { CE_PRICING_END_OF_TRIAL },
  } = useSplitTreatments({ names: [featureName] })

  return CE_PRICING_END_OF_TRIAL.treatment === 'on'
}
